// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__3A9Rj","main":"Layout_main__23b_t","hideFooter":"Layout_hideFooter__3VQa-"};